import { observable, runInAction, action, makeObservable } from "mobx";
import { API } from "General/API";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

class CustomerTextBlockStore extends CoreStore {
  html: { de: string; en: string } = { de: "", en: "" };
  active = false;

  constructor() {
    super();

    makeObservable(this, {
      html: observable,
      active: observable,
      switch: action.bound,
      getCustomerInfoByLang: action.bound,
      fetch: action.bound,
      edit: action.bound,
    });
  }

  clear() {
    this.html = { de: "", en: "" };
  }

  url() {
    return API_URL.ADMIN.getCustomerInfo();
  }

  @handleStoreState()
  async fetch() {
    try {
      const customerInfo: API_CustomerInfo = await API.getData(this.url());
      runInAction(() => {
        this.html = { de: customerInfo.value.de, en: customerInfo.value.en };
        this.active = customerInfo.active;
      });
    } catch (err) {
      throw err;
    }
  }

  @handleStoreState()
  async edit(info: { de: string; en: string }) {
    const { de, en } = info;

    try {
      await API.editData(this.url(), { value: { de, en }, active: this.active });
      runInAction(() => {
        this.html = { de, en };
      });
    } catch (err) {
      throw err;
    }
  }

  switch(value: boolean) {
    this.active = value;
  }

  getCustomerInfoByLang = (language: "de" | "en") => this.html[language];
}

const customerTextBlockStore = new CustomerTextBlockStore();

export { customerTextBlockStore, CustomerTextBlockStore };
